<template>
    <div class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>История заказов</h2>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Заголовок</th>
                                <th>Опции</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in items">
                            <td>{{ item.id }}</td>
                            <td>{{ item.order_number}}</td>
                            <td>
                                <router-link class="btn btn-primary" :to="'/managers/histories/edit/' + item.order_number">Изменить</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
          'user_id'
        ],

        data() {
            return {
                items: []
            }
        },

        mounted() {
            this.axios
                .get(this.axios.defaults.baseURL + 'manager/histories/user/' + this.user_id)
                .then(response => {
                    this.items = response.data.histories;
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/manager/histories/Index.vue